import { Modal, IModal, TableComponent, IColumn } from '../../index';
import { Typography, Table } from '@mui/material/';
import { useTranslation } from 'react-i18next';
import { LocalizedColumns } from '../../../utils';

interface IKpiFormulasModal extends IModal {
  isHistorical?: boolean;
}

export const KpiFormulasColumns: IColumn[] = [
  {
    id: 'kpi',
    name: 'KPI',
  },
  {
    id: 'calculation',
    name: 'Calculation',
  },
] as const;

const KpiFormulasModal = ({ open, handleClose, isHistorical = false }: IKpiFormulasModal) => {
  const { t } = useTranslation();
  const header = () => {
    return (
      <>
        <Typography variant="h6">{t('kpiFormulas')}</Typography>
      </>
    );
  };

  const content = () => (
    <Table>
      <TableComponent
        rows={
          (isHistorical
            ? t('historicalKpi', { returnObjects: true })
            : t('kpi', { returnObjects: true })) as Record<string, unknown>[]
        }
        columns={LocalizedColumns(KpiFormulasColumns, t)}
      />
    </Table>
  );

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      header={header()}
      mainContent={content()}
      maxWidth="md"
    />
  );
};

export default KpiFormulasModal;
